/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-01-10 16:21:38
 */
 
import Api from "src/util/api";
import {PageDo, ResultPageDo, Result} from "src/types/base";
import { defaultNullValue } from 'src/config';
export declare namespace AlarmLogDOI {

	export interface RowDataI {
		
	}

	export interface QueryRowDataParamsI extends PageDo {
		keyword?: string
	}

}
export default class AlarmLogApi {
	/**
	 * 查询列表
	 * @param {AlarmLogDOI.QueryRowDataParamsI} params
	 * @returns {Promise<ResultPageDo<PeopleManageRowI[]>>}
	 */
	static async searchList(params: AlarmLogDOI.QueryRowDataParamsI):Promise<ResultPageDo<AlarmLogDOI.RowDataI[]>> {
		return Api.post('/monitor/select/alarm_log', {
            alarm_type: defaultNullValue,
            start_time: defaultNullValue,
            end_time: defaultNullValue,
            component: '',
            ...params
        })
	}

    static async exportAll(params: AlarmLogDOI.QueryRowDataParamsI):Promise<Result<{download_url: string}>> {
		return Api.post('/monitor/condition/alarm_log/export',{
            alarm_type: defaultNullValue,
            start_time: defaultNullValue,
            end_time: defaultNullValue,
            component: '',
            ...params
        })
    }
}